/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ContainerData } from '@core/aem/components/container/models/container-data.interface';
import { ContentItem } from '@core/aem/models/content-item.interface';
import { ContentResolver } from '@core/aem/models/content-resolver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
/**
 * Creates dynamic routes
 * All dynamic routes created on application init stage
 *
 * @export
 * @class DynamicRouteComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'tmo-dynamic-route',
  templateUrl: './dynamic-route.component.html',
  styleUrls: ['./dynamic-route.component.scss'],
})
export class DynamicRouteComponent implements OnInit, OnDestroy {
  /**
   * Holds value of ready
   *
   * @type {boolean}
   * @memberof DynamicRouteComponent
   */
  public ready: boolean;

  /**
   * Holds items
   *
   * @type {ContentItem<ContainerData>[]}
   * @memberof DynamicRouteComponent
   */
  public items: ContentItem<ContainerData>[];
  /**
   * Unsubscriber for all subscribtions
   */
  private ngUnsubscribe: Subject<void>;

  constructor(private route: ActivatedRoute) {
    this.ready = false;
    this.ngUnsubscribe = new Subject<void>();
  }

  /**
   * Subscribe to data
   *
   * @memberof DynamicRouteComponent
   */
  public ngOnInit(): void {
    this.route.data
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((res: ContainerData) => {
        if (res.items) {
          this.items = this.generateComponent(res.items);
          this.ready = true;
        }
      });
  }

  /**
   * Un subscribe from subscriptions
   *
   * @memberof DynamicRouteComponent
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Load dynamic components
   *
   * @private
   * @param {ContentItem<ContainerData>[]} rows
   * @returns {ContentItem<ContainerData>[]}
   * @memberof DynamicRouteComponent
   */
  private generateComponent(rows: ContentItem<ContainerData>[]): ContentItem<ContainerData>[] {
    return ContentResolver.generateComponents(rows);
  }
}
